/* ===== EN Upsell-Größen-Popup =====
   Ersetzt den platzraubenden Inline-Größen-Dropdown der Upsell-Karten:
   Klick auf „Hinzufügen" → Popup mit Größen → Auswahl setzt die Größe in der Karte
   und löst das NATIVE Theme-Add aus (kein eigenes Fetch/innerHTML-Swap → Theme
   managt Scroll-Lock, Re-Render & Upsell-Reload korrekt → kein Scroll-Freeze).
   Produkte ohne echte Varianten (has_only_default_variant) laufen normal durchs Theme.
*/
(function () {
  if (window.__enUpsellSize) return;
  window.__enUpsellSize = 1;

  function variantsOf(card) {
    try { return JSON.parse(card.querySelector('script[type="application/json"]').textContent); }
    catch (e) { return null; }
  }
  function optionLabel(v) {
    return (v.options && v.options.length === 1) ? v.options[0] : (v.option1 || v.title);
  }

  // Größe in der Karte setzen + Theme-eigenes Add auslösen
  function chooseAndAdd(card, variant) {
    var selects = card.querySelectorAll('[data-select]');
    if (selects.length && variant.options) {
      for (var i = 0; i < selects.length; i++) {
        if (variant.options[i] != null) {
          selects[i].value = variant.options[i];
          selects[i].dispatchEvent(new Event('change', { bubbles: true }));
        }
      }
    }
    var form = card.querySelector('form');
    if (!form) return;
    var idInput = form.querySelector('[name="id"]');
    if (idInput) idInput.value = variant.id;
    var addBtn = form.elements ? form.elements.add : form.querySelector('[name="add"]');
    card.setAttribute('data-en-pass', '1');   // Interceptor einmalig durchlassen
    if (form.requestSubmit) form.requestSubmit(addBtn || undefined);
    else if (addBtn) addBtn.click();
    else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
  }

  var pop = null;
  function closePop() { if (pop) { pop.remove(); pop = null; } document.removeEventListener('keydown', onKey); }
  function onKey(e) { if (e.key === 'Escape') closePop(); }

  function openPop(card) {
    closePop();
    var vs = variantsOf(card); if (!vs || !vs.length) return;
    var titleEl = card.querySelector('.cart-drawer__upsell-item-title');
    var name = titleEl ? titleEl.textContent.trim() : '';
    var label = (window.enI18n && window.enI18n.sizeSelect) || 'Größe wählen';
    var html = '<div class="en-size-pop__overlay"></div>' +
      '<div class="en-size-pop__sheet" role="dialog" aria-label="' + label + '">' +
      '<button type="button" class="en-size-pop__x" aria-label="Schließen">&times;</button>' +
      '<p class="en-size-pop__title">' + label + '</p>' +
      (name ? '<p class="en-size-pop__sub">' + name + '</p>' : '') +
      '<div class="en-size-pop__grid">';
    vs.forEach(function (v) {
      html += '<button type="button" class="en-size-pop__opt' + (v.available ? '' : ' is-soldout') + '"' +
        ' data-vid="' + v.id + '"' + (v.available ? '' : ' disabled') + '>' + optionLabel(v) + '</button>';
    });
    html += '</div></div>';
    pop = document.createElement('div');
    pop.className = 'en-size-pop';
    pop.innerHTML = html;
    document.body.appendChild(pop);
    document.addEventListener('keydown', onKey);
    pop.addEventListener('click', function (e) {
      if (e.target.closest('.en-size-pop__x') || e.target.classList.contains('en-size-pop__overlay')) { closePop(); return; }
      var opt = e.target.closest('.en-size-pop__opt');
      if (!opt || opt.disabled) return;
      var variant = vs.filter(function (v) { return String(v.id) === String(opt.getAttribute('data-vid')); })[0];
      closePop();
      if (variant) chooseAndAdd(card, variant);
    });
  }

  // Add-Submit der Upsell-Karten abfangen (Capture-Phase, vor dem Theme-Handler)
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || !form.matches || !form.matches('form')) return;
    var card = form.closest('cart-drawer-upsell');
    if (!card) return;
    if (card.getAttribute('data-en-pass')) { card.removeAttribute('data-en-pass'); return; }   // unsere Auswahl → Theme-Add durchlassen
    if (!card.classList.contains('cart-drawer__upsell-item--has-variants')) return;
    var vs = variantsOf(card);
    if (!vs || vs.length < 2) return;     // nur 1 Variante → normal durchlassen
    e.preventDefault();
    e.stopImmediatePropagation();
    openPop(card);
  }, true);
})();
